export enum FilterIds {
  CUSTOMER = 'customer',
  EXTERNAL_COMPANY = 'external_company',
  LOCATION = 'location',
  LEAD_SOURCE = 'lead_source',
  AMOUNT = 'amount',
  CREATED_BY = 'created_by',
  INVOICE_STATUS = 'invoice_status',
  ESTIMATE_STATUS = 'estimate_status',
  TAGS = 'tags',
  SERVICE_AREA = 'service_area',
  CREATED_ON = 'created_on',
  JOB_STATUS = 'job_status',
  TEAM = 'team',
  REFERRAL_AMOUNT = 'referral_amount'
}
